import React from "react"
import FontAwesome from "react-fontawesome"
import Authenticated from "../../lib/Authenticated"

export default function Home() {

  const authenticated = new Authenticated()

  return (
    <article className="welcomeHome mt-40 sm:mt-100">

      <h3 className="text-blue-500">Welcome, { authenticated.getUsername() }</h3>

      <h4>
        You are logged in as { authenticated.getAuthority() }
      </h4>
      <hr />

      <p>You can navigate your way through Onboarding using:</p>
      <p>
        <FontAwesome name="arrow-up" size="lg" />&nbsp;
        the dropdown menu at the top-right to generate reports, configure your account and log out 
      </p>
      <p className="m_hide md:block">
        <FontAwesome name="arrow-left" size="lg" />&nbsp;
        the shortcuts to the left
      </p>

      <p className="mt-40 align-center">
        <img src={ require("../../files/logo.png") }
          alt="Logo" width="300"
          className="w-100p sm:w-300"
        />
      </p>
    </article>
  )
}



// WEBPACK FOOTER //
// ./src/components/Home/index.js